// Angular
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';

// Libraries
import { takeWhile } from 'rxjs/operators';

// Models
import { UnitPeriodChannelDto } from '../../../channel/models/unit-period-channel-dto.model';
import { AppCleanup, DynamicTableColumn, DynamicTableType } from '../../../../shared/models';

// Services
import { JobService } from '../../services/job.service';
import { JobUpdate } from '../../models';

@Component({
	selector: 'job-alerts-edit-dialog',
	templateUrl: './job-alerts-edit-dialog.component.html',
	styleUrls: ['./job-alerts-edit-dialog.component.scss'],
})
export class JobAlertsEditDialogComponent extends AppCleanup implements OnInit, OnDestroy {
	componentTitle: string = 'Edit job alerts/alarms';
	unitPeriodChannels: UnitPeriodChannelDto[];
	columnList: DynamicTableColumn[] = [
		{
			name: 'channel.label',
			display: 'File Name',
			width: 2,
		},
		{
			name: 'lowWarning',
			display: 'Low Warn',
			type: DynamicTableType.NUMBER,
			editable: this.isViewer,
			width: 1,
		},
		{
			name: 'lowDanger',
			display: 'Low Alert',
			type: DynamicTableType.NUMBER,
			editable: this.isViewer,
			width: 1,
		},

		{
			name: 'highWarning',
			display: 'High Warn',
			type: DynamicTableType.NUMBER,
			editable: this.isViewer,
			width: 1,
		},
		{
			name: 'highDanger',
			display: 'High Alert',
			type: DynamicTableType.NUMBER,
			editable: this.isViewer,
			width: 1,
		},
	];

	/**data parameter is passed from Parent component when Dialog is instantiated. Used here to get the job key from parent. */
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: { key: string },
		private jobService: JobService,
		public dialogRef: MatDialogRef<JobAlertsEditDialogComponent>
	) {
		super();
	}

	ngOnInit() {
		this.subscribeToJob();
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	/**
	 * Subscribes to jobChange$ from JobService and gets the Job Channels for Job. Assigns jobChannels as the data source for the Mat-Table data.
	 */
	private subscribeToJob() {
		//Waiting on Job so we only get this once. Otherwise the values will clear when a user could be editing the form.
		let waitingOnJob = true;

		this.jobService
			.getJobStream(String(this.data.key))
			.pipe(takeWhile(() => waitingOnJob))
			.subscribe((jobUpdate: JobUpdate) => {
				if (jobUpdate) {
					waitingOnJob = false;
					let unitPeriodChannels = this.jobService.findUnitPeriodChannelsForJob(jobUpdate.job.key);
					this.unitPeriodChannels = [...unitPeriodChannels];
				}
			});

		// this.jobService.jobChange$.pipe(takeWhile(() => waitingOnJob)).subscribe((jobChange) => {
		// 	if (jobChange?.job.key === this.data.key) {
		// 		waitingOnJob = false;
		// 		let unitPeriodChannels = this.jobService.findUnitPeriodChannelsForJob(jobChange.job.key);
		// 		this.unitPeriodChannels = [...unitPeriodChannels];
		// 	}
		// });
	}

	submit() {
		this.dialogRef.close({
			key: this.data.key,
			jobChannels: this.unitPeriodChannels,
		});
	}
}
